/**
 * RangeFieldSettings - слайдер для числовых значений
 */
import React from 'react';

export default function RangeFieldSettings({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  unit = '%', // единица измерения для отображения
  showValue = true,
  valueFormatter, // (value) => string
}) {
  const displayValue = valueFormatter
    ? valueFormatter(value)
    : `${value}${unit}`;

  return (
    <div>
      <label className="block text-sm font-medium mb-1">
        {label}{showValue && `: ${displayValue}`}
      </label>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value ?? min}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full"
      />
    </div>
  );
}
